<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-page-header :content="title" @back="back"> </el-page-header>
    <el-collapse
      v-model="activeName"
      class="mt-20px overflow-auto border"
      style="height: calc(100% - 108px)"
    >
      <el-form label-width="150px" :model="formData" ref="form" :rules="rules">
        <el-collapse-item title="基本信息" name="1">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="模型编码" prop="code">
                <el-input
                  placeholder="1-64个字符，仅支持小写英文、下划线、数字，不可重名"
                  v-model="formData.code"
                  minlength="1"
                  maxlength="64"
                  show-word-limit
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模型名称" prop="name">
                <el-input
                  placeholder="1-32个字符，仅支持中英文、数字、下划线"
                  v-model="formData.name"
                  minlength="1"
                  maxlength="32"
                  show-word-limit
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="描述">
                <el-input placeholder="请输入" v-model="formData.description" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="数据表定义" name="2">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="标准库" prop="standardId">
                <el-select
                  v-model="formData.standardId"
                  clearable
                  filterable
                  @change="changeStandardId"
                  class="!w-full"
                >
                  <el-option
                    v-for="(item, index) in standardList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <ul class="flex bg-title h-40px leading-40px border divide-x">
            <li class="w-1/4 pl-20px">实体表</li>
            <li class="w-1/4 pl-20px">关联实体表</li>
            <li class="w-1/4 pl-20px">关联方式与条件</li>
            <li class="w-1/4 pl-20px">操作</li>
          </ul>
          <ul
            class="flex border divide-x"
            style="border-top: none"
            v-for="(item, index) in associationList"
            :key="index"
          >
            <li class="w-1/4 pl-20px pt-10px">
              <el-select
                v-model="item.sourceId"
                clearable
                filterable
                @change="changeClassId(index, item.sourceId)"
                class="mb-10px"
              >
                <el-option
                  v-for="(item, index) in item.classList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </li>
            <li class="w-1/4 pl-20px pt-10px">
              <el-select
                v-model="item.targetIdList"
                clearable
                filterable
                multiple
                @change="changeTargetId(index, item.targetIdList)"
                @remove-tag="removeTargetId(index, item.targetIdList)"
                class="mb-10px"
              >
                <el-option
                  v-for="(item, index) in item.classList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </li>
            <li class="w-1/4 pl-20px pt-10px">
              <span class="text-blue-500 cursor-pointer" @click="handleConfig(index)"
                >配置关联方式与条件</span
              ><span class="text-red-500" v-if="!item.isConfig">（未配置）</span>
              <span class="text-blue-500" v-else>（已配置）</span>
            </li>
            <li class="w-1/4 pl-20px pt-10px">
              <el-button
                @click="handleDataTable('add', index)"
                class="iconfont icon-line-add"
                size="mini"
              ></el-button>
              <el-button size="mini" @click="handleDataTable('subtract', index)">一</el-button>
            </li>
          </ul>
        </el-collapse-item>
        <el-collapse-item title="数据维度定义" name="3">
          <el-table
            class="mt-20px sortTable"
            border
            :data="dimensionList"
            height="300px"
            ref="multipleTable"
            :row-class-name="tableRowClassName"
          >
            <el-table-column label="名称" prop="name">
              <template slot-scope="scope">
                <div class="flex">
                  <div
                    v-if="scope.row.type === 0"
                    class="w-40px h-36px leading-36px text-yellow-500"
                  >
                    dim
                  </div>
                  <div
                    v-else-if="scope.row.type === 1"
                    class="w-40px h-36px leading-36px text-green-500"
                  >
                    123
                  </div>
                  <div v-else class="w-40px h-36px leading-36px text-blue-500">time</div>
                  <el-tooltip
                    placement="top"
                    content="名称重复，请检查后保存"
                    :disabled="!scope.row.repeatCode"
                  >
                    <el-input
                      placeholder="请输入"
                      v-model="scope.row.code"
                      clearable
                      :class="scope.row.repeatCode ? 'red-border' : ''"
                      @change="changeCode"
                    ></el-input>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="中文名称" prop="name">
              <template slot-scope="scope">
                <el-tooltip
                  placement="top"
                  content="中文名称重复，请检查后保存"
                  :disabled="!scope.row.repeatName"
                >
                  <el-input
                    placeholder="请输入"
                    v-model="scope.row.name"
                    clearable
                    :class="scope.row.repeatName ? 'red-border' : ''"
                    @change="changeName"
                  ></el-input>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="类型" prop="type" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 0">维度</div>
                <div v-else-if="scope.row.type === 1">度量</div>
                <div v-else>时间</div>
              </template>
            </el-table-column>
            <el-table-column label="数据表" prop="sourceId">
              <template slot-scope="scope">
                <el-select
                  placeholder="请选择"
                  v-model="scope.row.sourceId"
                  clearable
                  filterable
                  @change="changeSourceId(scope.row)"
                  :disabled="scope.row.disabled"
                >
                  <el-option
                    v-for="(item, index) in selectClassList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="物理字段" prop="sourceFieldId">
              <template slot-scope="scope">
                <div class="flex">
                  <el-tooltip placement="top">
                    <div slot="content">字段未建立物理映射，请选择物理字段建立映射关系</div>
                    <i
                      class="iconfont icon-bg-circleWarning text-red-500 leading-36px text-14px"
                      v-show="!scope.row.sourceFieldId"
                    ></i>
                  </el-tooltip>
                  <div v-if="scope.row.sourceFieldId" class="w-14px"></div>
                  <el-select
                    placeholder="请选择"
                    v-model="scope.row.sourceFieldId"
                    @change="changeSourceFieldId(scope.row)"
                    clearable
                    filterable
                    :disabled="scope.row.disabled"
                  >
                    <el-option
                      v-for="(item, index) in scope.row.attributeList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="字段类型" prop="sourceFieldTypeStr" width="100">
            </el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="300">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  v-if="_.includes([1, 2], scope.row.type)"
                  @click="validateDimensionTypeChange(scope.row, 0)"
                  >设为维度</el-button
                >
                <el-button
                  size="mini"
                  v-if="scope.row.type === 0"
                  @click="validateDimensionTypeChange(scope.row, 2)"
                  >设为时间</el-button
                >
                <el-button
                  size="mini"
                  v-if="scope.row.type === 0"
                  @click="validateDimensionTypeChange(scope.row, 1)"
                  >设为度量</el-button
                >
                <el-dropdown
                  trigger="click"
                  @command="($event) => handleCommand($event, scope.row)"
                  class="ml-10px"
                  size="mini"
                >
                  <el-button size="mini">
                    更多<i class="iconfont icon-line-right text-12px"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="dim">+dim维度</el-dropdown-item>
                    <el-dropdown-item command="123">+123度量</el-dropdown-item>
                    <el-dropdown-item command="time">+time时间</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-form>
    </el-collapse>
    <div class="mt-20px text-center">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="back">取消</el-button>
    </div>

    <!-- 配置关联方式与条件 -->
    <configureRelationships :dialogForm="dialogForm" @updateConfig="updateConfig" />
  </el-card>
</template>

<script>
import sortable from 'sortablejs'
import StdClassAttributeService from '@/services/bsApi/StdClassAttributeService'
import DataModelService from '@/services/DataModelService'
import stdClassListService from '@/services/stdClassListService'
import StandardManagementService from '@/services/common/StandardManagementService'
import configureRelationships from './components/ConfigureRelationships'

export default {
  name: 'AddModel',
  components: { configureRelationships },
  data() {
    return {
      activeName: ['1', '2', '3'],
      formData: {
        code: '',
        name: '',
        description: '',
        standardId: '',
      },
      rules: {
        code: [
          { required: true, message: '请输入模型编码', trigger: 'blur' },
          {
            pattern: /^[a-z0-9_]+$/, // 仅支持小写英文、下划线、数字
            message: '仅支持小写英文、下划线、数字',
            trigger: 'blur',
          },
        ],
        name: [
          { required: true, message: '请输入模型名称', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/, // 仅支持中英文、数字、下划线
            message: '仅支持中英文、数字、下划线',
            trigger: 'blur',
          },
        ],
        standardId: [{ required: true, message: '请选择标准库', trigger: 'change' }],
      },
      dialogForm: {
        visiable: false,
        conditionList: [],
        rowIndex: 0,
        isConfig: false,
        type: '',
      },
      associationList: [
        {
          id: '',
          standardId: '',
          sourceId: '',
          targetId: '',
          targetIdList: [], // 多选
          classList: [],
          isConfig: false, // 是否配置关联方式与条件
          configList: [], // 配置关联方式与条件
          checkList: [], // 验证关联关系
        }, // associationType: 0(内连接)，1（左连接），2（右连接），3（外部连接）
      ], // 数据表定义
      standardList: [],
      dimensionList: [], // 数据维度定义 type: 0(维度dim)，1（度量123），2（时间time）
      classList: [], // 实体表
      attributeObj: {}, // 属性合集
      id: '',
      title: '',
      type: '',
      valueTypeList: [], // 字段类型
      selectClassList: [], // 数据表里被选中的实体表和关联实体表
    }
  },
  methods: {
    // 数据维度定义的行拖拽
    moveTableRow() {
      const el = document.querySelector('.sortTable .el-table__body-wrapper tbody')
      const that = this
      sortable.create(el, {
        oneEnd({ newIndex, oldIndex }) {
          const currentRow = that.dimensionList.splice(oldIndex, 1)[0]
          that.dimensionList.splice(newIndex, 0, currentRow)
        },
      })
    },
    // 数据维度定义，要限制可以选择的数据表
    handleSelectTable() {
      this.selectClassList = []
      let selectList = []
      _.map(this.associationList, (item) => {
        if (item.sourceId) selectList.push(item.sourceId)
        if (item.targetIdList && item.targetIdList.length > 0) {
          selectList = selectList.concat(item.targetIdList)
        }
      })
      _.map(selectList, (item) => {
        const currentSelect = _.find(this.classList, ['id', item])
        if (currentSelect) {
          this.selectClassList.push(currentSelect)
        }
      })
    },
    // 修改名称
    changeCode() {
      this.checkNameAndCode('code', 'repeatCode')
    },
    // 修改中文名称
    changeName() {
      this.checkNameAndCode('name', 'repeatName')
    },
    // 校验name和code
    checkNameAndCode(val, type) {
      _.map(this.dimensionList, (item, index) => {
        let flag = false
        _.map(this.dimensionList, (dItem, dIndex) => {
          if (item[val] === dItem[val] && index !== dIndex) {
            flag = true
            this.$set(this.dimensionList[dIndex], type, true)
          }
        })
        if (flag) {
          this.$set(this.dimensionList[index], type, true)
        } else {
          this.$set(this.dimensionList[index], type, false)
        }
      })
    },
    // 获取模型详情
    async getModelDetail() {
      if (!this.id) return
      const res = await DataModelService.getModelDetail(this.id)
      if (res && res.code === 0 && res.data) {
        if (this.type === 'update') {
          this.formData.name = res.data.name
          this.formData.code = res.data.code
          this.formData.description = res.data.description
        }
        this.formData.standardId = res.data.associationList[0].standardId
        const resAssociationList = _.cloneDeep(res.data.associationList)
        this.dimensionList = res.data.dimensionList
        // 获取实体表
        await this.getClassList(this.formData.standardId, resAssociationList)
        // 获取属性合集
        _.map(res.data.associationList, async (item, index) => {
          if (index === 0) {
            this.attributeObj[item.sourceId] = await this.getAttributeList(item.sourceId)
          }
          if (item.targetId) {
            this.attributeObj[item.targetId] = await this.getAttributeList(item.targetId)
          } else {
            this.attributeObj[item.targetId] = []
          }
          if (Object.keys(this.attributeObj).length - 1 === res.data.associationList.length) {
            // 等属性合集加载完 再处理数据
            _.map(this.dimensionList, async (dItem, dIndex) => {
              this.$set(
                this.dimensionList[dIndex],
                'attributeList',
                this.attributeObj[dItem.sourceId]
              )
              return dItem
            })
            _.map(res.data.associationList, (aItem, aIndex) => {
              // 处理配置关联方式与条件
              const table1Obj = _.find(this.classList, ['id', aItem.sourceId])
              const table2Obj = _.find(this.classList, ['id', aItem.targetId])
              const configList = [
                {
                  table1Id: aItem.sourceId,
                  table2Id: aItem.targetId,
                  table1Name: table1Obj ? table1Obj.name : '',
                  table2Name: table2Obj ? table2Obj.name : '',
                  table1Code: table1Obj ? table1Obj.code : '',
                  table2Code: table2Obj ? table2Obj.code : '',
                  associationType: aItem.associationType,
                  standardId: aItem.standardId,
                  conditions: aItem.conditions,
                  table1AttributeList: this.attributeObj[aItem.sourceId],
                  table2AttributeList: this.attributeObj[aItem.targetId],
                },
              ]
              this.$set(resAssociationList[aIndex], 'configList', configList)
              if (configList[0].conditions.length > 0) {
                this.$set(resAssociationList[aIndex], 'isConfig', true)
              } else {
                this.$set(resAssociationList[aIndex], 'isConfig', false)
              }
              // 处理验证关联关系
              const checkList = [
                {
                  standardId: aItem.standardId,
                  sourceId: aItem.sourceId,
                  targetId: aItem.targetId,
                  associationType: aItem.associationType,
                  conditions: aItem.conditions,
                  id: aItem.id,
                },
              ]
              this.$set(resAssociationList[aIndex], 'checkList', checkList)
            })
            _.map(resAssociationList, (cItem, cIndex) => {
              if (!cItem) return
              let targetIdList
              if (cItem.targetId) {
                targetIdList = [cItem.targetId]
              } else {
                targetIdList = []
              }
              const indexList = []
              _.map(resAssociationList, (aItem, aIndex) => {
                if (
                  cItem.sourceId === aItem.sourceId &&
                  cItem.targetId !== aItem.targetId &&
                  cIndex < aIndex
                ) {
                  targetIdList.push(aItem.targetId)
                  indexList.unshift(aIndex)
                  resAssociationList[cIndex].configList = cItem.configList.concat(
                    resAssociationList[aIndex].configList
                  )
                  resAssociationList[cIndex].checkList = cItem.checkList.concat(
                    resAssociationList[aIndex].checkList
                  )
                }
              })
              if (targetIdList.length >= 1) {
                this.$set(resAssociationList[cIndex], 'targetIdList', targetIdList)
                this.$set(resAssociationList[cIndex], 'targetId', targetIdList.join(','))
                _.map(indexList, (i) => {
                  resAssociationList.splice(i, 1)
                })
              }
            })
            this.associationList = resAssociationList
            this.handleSelectTable()
          }
        })
      }
    },
    // 保存
    async save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.associationList[0].sourceId === '') {
            this.$message.info('请选择实体表')
            return
          }
          const errList = _.filter(this.dimensionList, (item) => {
            return item.error
          })
          if (errList.length > 0) {
            this.$message.warning('字段类型变更失败，无法保存')
            return
          }
          let associationList = []
          _.map(this.associationList, (item) => {
            associationList = associationList.concat(item.checkList)
          })
          // 单表单独处理
          if (associationList.length === 0) {
            _.map(this.associationList, (item) => {
              associationList.push({
                standardId: item.standardId,
                sourceId: item.sourceId,
              })
            })
          }
          if (this.type === 'update') {
            this.updateModel(associationList)
          } else {
            this.addModel(associationList)
          }
        }
      })
    },
    // 新增模型
    async addModel(associationList) {
      const res = await DataModelService.addModel({
        code: this.formData.code,
        name: this.formData.name,
        description: this.formData.description,
        associationList,
        dimensionList: this.dimensionList,
      })
      if (res && res.code === 0) {
        this.$message.success('新增模型成功')
        this.back()
      }
    },
    // 编辑模型
    async updateModel(associationList) {
      const res = await DataModelService.updateModel(this.id, {
        id: this.id,
        code: this.formData.code,
        name: this.formData.name,
        description: this.formData.description,
        associationList,
        dimensionList: this.dimensionList,
      })
      if (res && res.code === 0) {
        this.$message.success('修改模型成功')
        this.back()
      }
    },
    // 新增和删除数据表
    handleDataTable(type, index) {
      if (type === 'add') {
        const addRow = {
          standardId: this.formData.standardId,
          sourceId: '',
          targetId: '',
          targetIdList: [],
          classList: this.classList,
          isConfig: false,
          configList: [],
          checkList: [],
        }
        this.associationList.splice(index + 1, 0, addRow)
      } else if (type === 'subtract') {
        if (this.associationList.length === 1) {
          this.$message.warning('仅剩一行，不能删除')
          return
        }
        this.associationList.splice(index, 1)
      }
    },
    // 验证维度类型变更
    async validateDimensionTypeChange(row, type, operate) {
      const res = await DataModelService.validateDimensionTypeChange({
        type,
        sourceId: row.sourceId,
        sourceFieldId: row.sourceFieldId,
      })
      if (res && res.code === 0) {
        this.dimensionList[row.index].type = type
        this.$set(this.dimensionList[row.index], 'error', false)
      } else if (operate === 'add' && res.code === 1) {
        this.$set(this.dimensionList[row.index], 'error', true)
      }
    },
    // 修改数据表
    async changeSourceId(row) {
      if (row.sourceFieldId) {
        this.dimensionList[row.index].sourceFieldId = ''
      }
      this.dimensionList[row.index].attributeList = await this.getAttributeList(row.sourceId)
    },
    // 修改物理字段
    changeSourceFieldId(row) {
      if (row.sourceFieldId) {
        // 验证维度类型
        this.validateDimensionTypeChange(row, row.type, 'add')
        const currentFieldRow = _.find(this.dimensionList[row.index].attributeList, [
          'id',
          row.sourceFieldId,
        ])
        this.dimensionList[row.index].code = currentFieldRow.code
        this.dimensionList[row.index].name = currentFieldRow.name
        this.checkNameAndCode('code', 'repeatCode')
        this.checkNameAndCode('name', 'repeatName')
        this.dimensionList[row.index].sourceFieldType = currentFieldRow.valueType
        const currentTypeRow = _.find(this.valueTypeList, ['value', currentFieldRow.valueType])
        this.dimensionList[row.index].sourceFieldTypeStr = currentTypeRow.name
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
      row.seqNo = rowIndex
    },
    // 更新配置信息
    updateConfig(val, index) {
      this.associationList[index].isConfig = true
      this.associationList[index].configList = _.cloneDeep(val)
      const checkList = _.map(val, (item) => {
        return {
          standardId: item.standardId,
          sourceId: item.table1Id,
          targetId: item.table2Id,
          associationType: item.associationType,
          conditions: item.conditions,
          id: item.id ? item.id : '',
        }
      })
      this.associationList[index].checkList = _.cloneDeep(checkList)
      this.checkModel(checkList, index)
    },
    // 校验数据模型关联关系
    async checkModel(data, index) {
      const res = await DataModelService.checkModel(data)
      if (res && res.code === 0) {
        this.getDataDimension(data, index)
      }
    },
    // 根据模型关联关系获取数据维度
    async getDataDimension(data, i) {
      const res = await DataModelService.getDataDimension(data)
      if (res && res.code === 0 && res.data) {
        if (this.dimensionList.length > 0 && i > 0) {
          const list = []
          // 大于第一行的数据表需要去掉前面行的重复字段
          _.map(res.data, (item) => {
            let flag = false
            _.map(this.dimensionList, (aItem) => {
              if (item.sourceId === aItem.sourceId && item.sourceFieldId === aItem.sourceFieldId) {
                flag = true
              }
            })
            if (!flag) {
              list.push(item)
            }
          })
          this.dimensionList = this.dimensionList.concat(list)
        } else {
          this.dimensionList = res.data
        }
        const keyList = Object.keys(this.attributeObj)
        _.map(this.dimensionList, (item, index) => {
          item.disabled = true // 配置关联方式与条件带出来的维度列表，物理字段不能修改
          if (_.includes(keyList, item.sourceId)) {
            this.$set(this.dimensionList[index], 'attributeList', this.attributeObj[item.sourceId])
          }
          return item
        })
        this.checkRepeat(this.dimensionList)
      }
    },
    // 重复的名称和code要添加提示
    checkRepeat(data) {
      _.map(data, (item, index) => {
        _.map(data, (dItem, dIndex) => {
          if (item.code === dItem.code && index !== dIndex) {
            this.$set(data[index], 'repeatCode', true)
            this.$set(data[dIndex], 'repeatCode', true)
          }
          if (item.name === dItem.name && index !== dIndex) {
            this.$set(data[index], 'repeatName', true)
            this.$set(data[dIndex], 'repeatName', true)
          }
        })
      })
    },
    back() {
      this.$router.go(-1)
    },
    // 更多操作
    handleCommand(command, row) {
      const addRow = {
        standardId: row.standardId,
        code: '',
        name: '',
        type: 0,
        sourceId: '',
        sourceFieldId: '',
        attributeList: [],
      }
      if (command === 'dim') {
        addRow.type = 0
        this.dimensionList.splice(row.index + 1, 0, addRow)
      } else if (command === '123') {
        addRow.type = 1
        this.dimensionList.splice(row.index + 1, 0, addRow)
      } else if (command === 'time') {
        addRow.type = 2
        this.dimensionList.splice(row.index + 1, 0, addRow)
      } else if (command === 'delete') {
        this.dimensionList.splice(row.index, 1)
      }
    },
    // 获取标准库列表
    async getStandardList() {
      const res = await StandardManagementService.getList({ keyword: '' })
      if (res && res.code === 0 && res.data) {
        this.standardList = _.map(res.data, (item) => {
          return {
            name: item.name,
            code: item.code,
            id: item.id,
          }
        })
      }
    },
    // 获取实体列表
    async getClassList(standardId, data) {
      const res = await stdClassListService.getClassList({
        standard_id: standardId,
        data_type: 1,
        approve_status: 1, // 已发布的实体
      })
      if (res && res.code === 0 && res.data) {
        this.classList = _.map(res.data, (item) => {
          return {
            code: item.code,
            name: item.name,
            id: item.id,
            disabled: false,
          }
        })
        _.map(data, (item) => {
          item.classList = this.classList
          _.map(item.classList, (cItem) => {
            if (item.sourceId === cItem.id) {
              cItem.disabled = true
            } else {
              cItem.disabled = false
            }
            return cItem
          })
          return item
        })
      }
    },
    // 获取属性列表
    async getAttributeList(classId) {
      const res = await stdClassListService.getAttrList({ class_id: classId })
      if (res && res.code === 0 && res.data) {
        const list = _.map(res.data, (item) => {
          return {
            code: item.code,
            name: item.name,
            id: item.id,
            valueType: item.valueType,
          }
        })
        return list
      }
      return []
    },
    // 修改标准库
    changeStandardId(val) {
      this.getClassList(val, this.associationList)
      this.dimensionList = []
      _.map(this.associationList, (item) => {
        item.standardId = this.formData.standardId
        item.sourceId = ''
        item.targetId = ''
        item.targetIdList = []
        item.isConfig = false
        item.configList = []
        item.checkList = []
        return item
      })
    },
    // 过滤数据维度
    filterDimension() {
      const sourceIdList = []
      _.map(this.associationList, (item) => {
        if (item.sourceId) sourceIdList.push(item.sourceId)
      })
      if (sourceIdList.length === 0) {
        this.dimensionList = []
      } else {
        _.filter(this.dimensionList, (item) => {
          return _.includes(sourceIdList, item.sourceId)
        })
      }
    },
    // 修改实体表
    async changeClassId(index, val) {
      this.handleSelectTable()
      _.map(this.associationList[index].classList, (item) => {
        if (item.id === val) {
          item.disabled = true
        } else {
          item.disabled = false
        }
        return item
      })
      // 选择单个实体表，获取维度信息
      if (!val) {
        this.filterDimension()
        return
      }
      const attributeList = await this.getAttributeList(val)
      this.attributeObj[val] = attributeList
      this.associationList[index].isConfig = false
      this.getDataDimension(
        [
          {
            standardId: this.formData.standardId,
            sourceId: val,
          },
        ],
        index
      )
    },
    // 修改关联实体表
    changeTargetId(index, idList) {
      this.handleSelectTable()
      const keyList = Object.keys(this.attributeObj)
      _.map(idList, async (id) => {
        if (!_.includes(keyList, id)) {
          const attributeList = await this.getAttributeList(id)
          this.attributeObj[id] = attributeList
        }
      })
      this.associationList[index].isConfig = false
    },
    // 多选模式下移除tag
    removeTargetId(index, idList) {
      this.handleSelectTable()
      // 删除关联实体表，同时要清理下面的关联的表的维度
      const checkList = this.associationList[index].checkList
      _.map(checkList, (item, i) => {
        if (!_.includes(idList, item.targetId)) {
          checkList.splice(i, 1)
        }
      })
      if (checkList.length > 0) {
        this.getDataDimension(checkList, index)
      }
      if (idList.length === 0 && this.associationList[index].sourceId) {
        // 选择单个实体表，获取维度信息
        this.getDataDimension(
          [
            {
              standardId: this.formData.standardId,
              sourceId: this.associationList[index].sourceId,
            },
          ],
          index
        )
      }
    },
    // 打开配置关联方式与条件对话框
    handleConfig(index) {
      if (!this.associationList[index].standardId) {
        this.$message.info('请选择标准库')
        return
      }
      if (!this.associationList[index].sourceId) {
        this.$message.info('请选择实体表')
        return
      }
      if (this.associationList[index].targetIdList.length === 0) {
        this.$message.info('请选择关联实体表')
        return
      }
      if (!this.associationList[index].isConfig) {
        // 未配置
        this.dialogForm.conditionList = []
        const table1Obj = _.find(this.classList, ['id', this.associationList[index].sourceId])
        const classList = this.associationList[index].targetIdList
        _.map(classList, (item) => {
          const table2Obj = _.find(this.classList, ['id', item])
          this.dialogForm.conditionList.push({
            table1Id: this.associationList[index].sourceId,
            table2Id: item,
            table1Name: table1Obj ? table1Obj.name : '',
            table2Name: table2Obj ? table2Obj.name : '',
            table1Code: table1Obj ? table1Obj.code : '',
            table2Code: table2Obj ? table2Obj.code : '',
            associationType: 0,
            standardId: this.associationList[index].standardId,
            conditions: [
              {
                sourceFieldId: '',
                targetFieldId: '',
              },
            ],
            table1AttributeList: this.attributeObj[this.associationList[index].sourceId],
            table2AttributeList: this.attributeObj[item],
          })
        })
      } else {
        // 已配置
        this.dialogForm.conditionList = this.associationList[index].configList
      }
      this.dialogForm.visiable = true
      this.dialogForm.rowIndex = index
      this.dialogForm.isConfig = this.associationList[index].isConfig
      if (this.id) {
        this.dialogForm.type = 'update'
      }
    },
    // 获取值类型列表
    async getValueTypeList() {
      const res = await StdClassAttributeService.getValueType()
      if (res && res.code === 0 && res.data) {
        this.valueTypeList = res.data
      }
    },
  },
  created() {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.type = this.$route.query.type ? this.$route.query.type : ''
    if (this.type === 'update') {
      this.title = '编辑模型'
      this.getModelDetail()
    } else if (this.type === 'copy') {
      this.title = '复制模型'
      this.getModelDetail()
    } else if (this.type === 'add') {
      this.title = '新增模型'
    }
    this.getStandardList()
    this.getValueTypeList()
    this.$nextTick(() => {
      this.moveTableRow()
    })
  },
}
</script>

<style lang="scss" scoped>

.bg-title {
  color: var(--titleTextColor);
  background-color: var(--collapseHeadHeaderBg);
  border-color: var(--collapseBorder);
}
.red-border /deep/.el-input__inner {
  border-color: red !important;
}

</style>
